module.exports = __webpack_public_path__ + "img/吉林一号网logo_white.691e3e7b.png";